/**
 * Colours and numbers associated with each graha.
 *
 * Read against the Birth Yogi: the Yogi planet's colours and number are the
 * favourable ones for that person to wear and use day to day.
 */

export const PLANET_TRAITS = {
  Sun: {
    number: 1,
    colours: ['Saffron', 'Gold', 'Bright orange'],
    meaning: 'leadership, ambition and strong will',
    colourMeaning: 'vitality, authority and confidence',
    // Approximate swatches, only for the colour dots in the UI.
    swatches: ['#f4a12a', '#d4a017', '#ff7a1a'],
  },
  Moon: {
    number: 2,
    colours: ['Pure white', 'Silver', 'Pearl'],
    meaning: 'intuition, emotions and sensitivity',
    colourMeaning: 'emotions, intuition and inner calm',
    swatches: ['#ffffff', '#c9ccd1', '#eae6dd'],
  },
  Jupiter: {
    number: 3,
    colours: ['Warm yellow', 'Honey', 'Mustard'],
    meaning: 'growth, abundance and wisdom',
    colourMeaning: 'wisdom, expansion and prosperity',
    swatches: ['#f2c94c', '#d9a441', '#c9a227'],
  },
  Rahu: {
    number: 4,
    colours: ['Smoky grey', 'Electric blue', 'Ultraviolet'],
    meaning: 'unexpected change and material drive',
    colourMeaning: 'mystery and innovation',
    swatches: ['#7d8590', '#2f6fed', '#7a3ff2'],
  },
  Mercury: {
    number: 5,
    colours: ['Emerald green', 'Lime'],
    meaning: 'communication, intelligence and versatility',
    colourMeaning: 'intellect, communication and adaptability',
    swatches: ['#1faa59', '#9fd356'],
  },
  Venus: {
    number: 6,
    colours: ['Pink', 'Rose', 'Soft white'],
    meaning: 'love, harmony and luxury',
    colourMeaning: 'love, beauty, harmony and the arts',
    swatches: ['#f19cb0', '#e0607e', '#f7f1ee'],
  },
  Ketu: {
    number: 7,
    colours: ['Earthy tan', 'Maroon', 'Ochre'],
    meaning: 'spirituality, detachment and intuition',
    colourMeaning: 'spirituality and detachment',
    swatches: ['#c8a882', '#7b2d3b', '#cc7722'],
  },
  Saturn: {
    number: 8,
    colours: ['Indigo', 'Deep navy', 'Dark blue', 'Charcoal'],
    meaning: 'discipline, karma and hard work',
    colourMeaning: 'discipline, structure and endurance',
    swatches: ['#3b3b8f', '#1b2a52', '#22436e', '#36393d'],
  },
  Mars: {
    number: 9,
    colours: ['Bright red', 'Crimson', 'Scarlet'],
    meaning: 'energy, courage and action',
    colourMeaning: 'passion, drive, courage and physical energy',
    swatches: ['#e03131', '#a4133c', '#d62828'],
  },
};

/**
 * Favourable colours and number for a chart, taken from its Birth Yogi.
 * @returns {{planet, number, colours, swatches, meaning, colourMeaning}|null}
 */
export function favourablesFor(birthYogi) {
  const t = PLANET_TRAITS[birthYogi];
  if (!t) return null;
  return { planet: birthYogi, ...t };
}

export default favourablesFor;
